import { useEffect, useState } from 'react';
import { studioApi } from '@/lib/studioApi';

const cache = new Map();
export const fetchSprite = body => {
  const key = JSON.stringify(body);
  if (!cache.has(key)) {
    if (cache.size > 80) cache.delete(cache.keys().next().value);
    cache.set(key, studioApi('/text-preview', { method: 'POST', body }).catch(e => { cache.delete(key); throw e; }));
  }
  return cache.get(key);
};

// Server-rendered text sprite (warps, text masks); keeps the last result visible while the next one loads.
export const useServerSprite = body => {
  const [sprite, setSprite] = useState(null), key = body ? JSON.stringify(body) : null;
  useEffect(() => {
    if (!key) return undefined;
    let alive = true;
    const t = setTimeout(() => fetchSprite(JSON.parse(key)).then(r => { if (alive) setSprite({ ...r, key }); }).catch(() => {}), 200);
    return () => { alive = false; clearTimeout(t); };
  }, [key]);
  return key ? sprite : null;
};
